import { configureStore } from '@reduxjs/toolkit';

import { projectVenueMonthDeclarationSlice } from '@/domain//project-venue-month-declaration/project-venue-month-declarations.slice';
import { authSlice } from '@/domain/auth/auth.slice';
import { earlyFeatureSlice } from '@/domain/early-feature/early-feature.slice';
import { externalSlice } from '@/domain/external/external.slice';
import { externalInvitationSlice } from '@/domain/external-invitation/external-invitation.slice';
import { externalInvitationSurveySlice } from '@/domain/external-invitation-survey/external-invitation-survey.slice';
import { impactCalculateFestivalSlice } from '@/domain/impact-calculate-festival/impact-calculate-festival.slice';
import { impactCalculateTourSlice } from '@/domain/impact-calculate-tour/impact-calculate-tour.slice';
import { impactCalculateVenueSlice } from '@/domain/impact-calculate-venue/impact-calculate-venue.slice';
import { impactCo2Slice } from '@/domain/impact-co2/impact-co2.slice';
import { impactEnvSlice } from '@/domain/impact-env/impact-env.slice';
import { impactEssSlice } from '@/domain/impact-ess/impact-ess.slice';
import { impactReferences } from '@/domain/impact-references/impact-references.slice';
import { impactStatsSlice } from '@/domain/impact-stats/impact-stats.slice';
import { organisationSlice } from '@/domain/organisation/organisation.slice';
import { projectSlice } from '@/domain/project/project.slice';
import { projectFestivalSlice } from '@/domain/project-festival/project-festival.slice';
import { projectTourSlice } from '@/domain/project-tour/project-tour.slice';
import { projectVenueSlice } from '@/domain/project-venue/project-venue.slice';
import { projectVenueDatesSlice } from '@/domain/project-venue-dates/project-venue-dates.slice';
import { projectVenuePresetsSlice } from '@/domain/project-venue-presets/project-presets.slice.ts';
import { tagsSlice } from '@/domain/tags/tags.slice.ts';

import { projectTourOntourSlice } from './project-tour-ontour/project-tour-ontour.slice';
import { thunkExtraArgument } from './store.thunk';

const isReduxDevToolsEnabled = import.meta.env.MODE !== 'production';

export const store = configureStore({
  reducer: {
    [authSlice.name]: authSlice.reducer,
    [earlyFeatureSlice.name]: earlyFeatureSlice.reducer,
    [organisationSlice.name]: organisationSlice.reducer,
    [tagsSlice.name]: tagsSlice.reducer,
    [projectSlice.name]: projectSlice.reducer,
    [projectFestivalSlice.name]: projectFestivalSlice.reducer,
    [projectVenueSlice.name]: projectVenueSlice.reducer,
    [projectVenueDatesSlice.name]: projectVenueDatesSlice.reducer,
    [projectVenueMonthDeclarationSlice.name]:
      projectVenueMonthDeclarationSlice.reducer,
    [projectVenuePresetsSlice.name]: projectVenuePresetsSlice.reducer,
    [projectTourSlice.name]: projectTourSlice.reducer,
    [projectTourOntourSlice.name]: projectTourOntourSlice.reducer,
    [impactReferences.name]: impactReferences.reducer,
    [impactCalculateFestivalSlice.name]: impactCalculateFestivalSlice.reducer,
    [impactCalculateVenueSlice.name]: impactCalculateVenueSlice.reducer,
    [impactCalculateTourSlice.name]: impactCalculateTourSlice.reducer,
    [impactCo2Slice.name]: impactCo2Slice.reducer,
    [impactEssSlice.name]: impactEssSlice.reducer,
    [impactEnvSlice.name]: impactEnvSlice.reducer,
    [impactStatsSlice.name]: impactStatsSlice.reducer,
    [externalSlice.name]: externalSlice.reducer,
    [externalInvitationSlice.name]: externalInvitationSlice.reducer,
    [externalInvitationSurveySlice.name]: externalInvitationSurveySlice.reducer,
  },
  devTools: isReduxDevToolsEnabled,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      thunk: {
        extraArgument: thunkExtraArgument,
      },
    });
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
